<template>

    <Loader v-if="isPreloaderEnabled" />
    <router-view></router-view>

    <v-dialog
      v-model="taskBoard"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
      style="max-width: 99.9%;margin: 0;z-index: 1003;"
    >
        <v-card
        ref="dialogCard"
        >
        <!-- Custom Header -->
        <v-toolbar
          style="cursor: move; position: fixed; z-index: 1000;"
          :height="40"
          elevation="0"
          class="kanban-toolbar"
        >
          <!-- Left: icon + title -->
          <div class="kanban-toolbar__left">
            <div class="kanban-toolbar__icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="3" width="7" height="7" rx="1.5" fill="currentColor"/>
                <rect x="14" y="3" width="7" height="7" rx="1.5" fill="currentColor" opacity=".7"/>
                <rect x="3" y="14" width="7" height="7" rx="1.5" fill="currentColor" opacity=".7"/>
                <rect x="14" y="14" width="7" height="7" rx="1.5" fill="currentColor" opacity=".4"/>
              </svg>
            </div>
            <span class="kanban-toolbar__title">Task Board</span>
            <div class="kanban-toolbar__badge">Topshiriqlar</div>
          </div>

          <v-spacer />

          <!-- Right: actions -->
          <div class="kanban-toolbar__actions">
            <button class="kanban-toolbar__btn" @click="$refs.kanbanboard.refreshPage()" title="Yangilash">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
                <path d="M3 3v5h5"/>
              </svg>
            </button>

            <div class="kanban-toolbar__divider"></div>

            <button class="kanban-toolbar__btn kanban-toolbar__btn--close" @click="closeDialog" title="Yopish">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
                <path d="M18 6 6 18M6 6l12 12"/>
              </svg>
            </button>
          </div>
        </v-toolbar>

        <!-- Kanban Board Content -->
        <v-card-text
            class="pa-0 custom-background-color"
            style="margin-top: 40px;"
        >
            <KanbanBoard ref="kanbanboard" />
        </v-card-text>
        </v-card>
    </v-dialog>

</template>


<script>
import Loader from './components/UIComponents/Loader.vue';
import KanbanBoard from './views/Task/KanbanBoard.vue';

export default {
  components: { Loader, KanbanBoard },
  name: 'App',

  data() {
    return {
      isPreloaderEnabled: false
    }
  },

  computed: {
    taskBoard() {
      return this.$store.state.taskBoard
    }
  },

  methods: {
    closeDialog() {
      this.$store.commit('SET_TASKBOARD', false)
    }
  },

  async created() {
    if (this.$store.state.token) {
      await this.$store.dispatch('fetchUser');
    }
  },

  mounted() {
    const preloaderSetting = sessionStorage.getItem('preloader') ?? 'disable'
    this.isPreloaderEnabled = preloaderSetting === 'enable'

    // sessionStorage dan oldingi holatni tiklash
    const saved = sessionStorage.getItem('taskboard') === 'true'
    if (saved) this.$store.commit('SET_TASKBOARD', true)
  }
}
</script>
<style scoped>

.kanban-toolbar {
  background: #ffffff !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07) !important;
}

[data-bs-theme="dark"] .kanban-toolbar {
  background: #0f1623 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07) !important;
}

.kanban-toolbar__left {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 16px;
}

.kanban-toolbar__icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.kanban-toolbar__title {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: 0.01em;
}

[data-bs-theme="dark"] .kanban-toolbar__title {
  color: #f0f4ff;
}

.kanban-toolbar__badge {
  font-size: 10px;
  font-weight: 500;
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 100px;
  padding: 2px 8px;
  letter-spacing: 0.03em;
}

.kanban-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-right: 12px;
}

.kanban-toolbar__divider {
  width: 1px;
  height: 16px;
  background: rgba(0, 0, 0, 0.1);
  margin: 0 4px;
}

[data-bs-theme="dark"] .kanban-toolbar__divider {
  background: rgba(255, 255, 255, 0.1);
}

.kanban-toolbar__btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background .15s, color .15s;
  flex-shrink: 0;
}

.kanban-toolbar__btn:hover {
  background: rgba(0, 0, 0, 0.06);
  color: #0f172a;
}

[data-bs-theme="dark"] .kanban-toolbar__btn {
  color: #8b9cc7;
}

[data-bs-theme="dark"] .kanban-toolbar__btn:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #f0f4ff;
}

.kanban-toolbar__btn--close:hover {
  background: rgba(239, 68, 68, 0.1) !important;
  color: #ef4444 !important;
}
</style>